import { RouterProvider } from 'react-router-dom';

// project-imports
import router from 'routes';
import NotificationSystem from 'components/NotificationSystem';
// import ThemeSwitcher from 'components/ThemeSwitcher';
import { ToastContainer } from 'react-toastify';
// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <NotificationSystem />
      <ToastContainer />
      {/* Theme Switcher for development - remove in production */}
      {/* <ThemeSwitcher /> */}
    </>
  );
}

export default App;
